import { Customer } from './Customer.model';

export class ProjectToApproval {
    hashTrackId: string;
    total_hours: number;
    name: string;
    customer: Customer = new Customer();
    projectFinancialId: string;
    excellenceCenter:{
        _id:string,
        name:string
    };
    approvedHours: number;
    approvedValue: number;
}



// WEBPACK FOOTER //
// ./src/app/models/ProjectToApproval.model.ts